import { search } from "../../../BaseRepositoryComponents";

const path = `${process.env.REACT_APP_URL_API_ERP}/erp/faturamento/contratoservicos/v1`;
const token = process.env.REACT_APP_TOKEN_API_ERP;

const headers = new Headers();
headers.append("Authorization", token);
headers.append("content-type", "application/json");

export const getViewLists = async ({ empresa_cnpj, empresa_id }) =>
  search(
    `${path}/getlistas?empresa_cnpj=${empresa_cnpj}&empresa_id=${empresa_id}`,
    "GET",
    headers
  );

export const findContratoServico = async ({ empresa_cnpj, id, include }) =>
  search(
    `${path}/${id}?empresa_cnpj=${empresa_cnpj}${
      include ? `&include=${include}` : ""
    }`,
    "GET",
    headers
  );

export const createContratoServico = async ({ body, empresa_cnpj }) =>
  search(`${path}?empresa_cnpj=${empresa_cnpj}`, "POST", headers, body);

export const updateContratoServico = async ({ id, body, empresa_cnpj }) =>
  search(`${path}/${id}?empresa_cnpj=${empresa_cnpj}`, "PUT", headers, body);
